import React from 'react'
import Card from '../Card/Card'
import './Inventory.css'

const Inventory = () => {
  return (
    <div>
      <Card
        img1={
          'https://img.huffingtonpost.com/asset/5cd7237b2100005900ca4de6.jpeg'
        }
        img2={
          'https://www.flare.com/wp-content/uploads/2012/10/622e439b412882f00d556a6c1415.jpg'
        }
      />
      <Card
        img1={
          'http://theimpression.com/wp-content/uploads/2017/09/fendi-rs18-1119.jpg'
        }
        img2={
          'https://theimpression.com/wp-content/uploads/2020/10/balmain-rs21-0215-scaled.jpg'
        }
      />
      <Card
        img1={
          'https://www.fashionotography.com/wp-content/uploads/2020/10/Dior-Spring-Summer-2021-Paris-Fashion-Week-18.jpeg'
        }
        img2={
          'https://i0.wp.com/www.vervemagazine.in/wp-content/uploads/2014/01/Aquilano.Rimondi-copy.jpg'
        }
      />
      <Card
        img1={
          'https://img.huffingtonpost.com/asset/5cd7237b2100005900ca4de6.jpeg'
        }
        img2={
          'https://www.flare.com/wp-content/uploads/2012/10/622e439b412882f00d556a6c1415.jpg'
        }
      />
      <Card
        img1={
          'http://theimpression.com/wp-content/uploads/2017/09/fendi-rs18-1119.jpg'
        }
        img2={
          'https://theimpression.com/wp-content/uploads/2020/10/balmain-rs21-0215-scaled.jpg'
        }
      />
      <Card
        img1={
          'https://www.fashionotography.com/wp-content/uploads/2020/10/Dior-Spring-Summer-2021-Paris-Fashion-Week-18.jpeg'
        }
        img2={
          'https://i0.wp.com/www.vervemagazine.in/wp-content/uploads/2014/01/Aquilano.Rimondi-copy.jpg'
        }
      />
      <Card
        img1={
          'https://img.huffingtonpost.com/asset/5cd7237b2100005900ca4de6.jpeg'
        }
        img2={
          'https://www.flare.com/wp-content/uploads/2012/10/622e439b412882f00d556a6c1415.jpg'
        }
      />
      <Card
        img1={
          'http://theimpression.com/wp-content/uploads/2017/09/fendi-rs18-1119.jpg'
        }
        img2={
          'https://theimpression.com/wp-content/uploads/2020/10/balmain-rs21-0215-scaled.jpg'
        }
      />
      <Card
        img1={
          'https://www.fashionotography.com/wp-content/uploads/2020/10/Dior-Spring-Summer-2021-Paris-Fashion-Week-18.jpeg'
        }
        img2={
          'https://i0.wp.com/www.vervemagazine.in/wp-content/uploads/2014/01/Aquilano.Rimondi-copy.jpg'
        }
      />
    </div>
  )
}

export default Inventory
